import { map } from 'utils';

export const formatMSelectLodgingPopupDetail = (input: any) => {
	return {
		...input,
	};
};

export const formatMSelectLodgingPopupList = (input: any) => {
	return map(input, formatMSelectLodgingPopupDetail);
};
